<template>
  <div>
    <eg-search-select
      :items="assignments"
      :value="selectedAssignment"
      title-key="name"
      entity="assignment"
      placeholder="Enter assignment name"
      :required="required"
      :submitted="submitted"
      show-create-entity
      hide-create-divider
      allow-custom-input
      empty-title="Create your first assignment by typing the assignment name"
      @input="selectAssignment($event)"
    >
    </eg-search-select>
  </div>
</template>

<script>
import EgSearchSelect from "@/components/global/eg_search_select.vue";

export default {
  name: "FolderAssignmentSelector",

  components: {
    EgSearchSelect,
  },

  inject: ["workspacesProvider"],

  props: {
    value: {
      type: Object,
      default: null,
    },
    assignments: {
      type: Array,
      default: () => [],
    },
    selectedClass: {
      type: Object,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    submitted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedAssignment: null,
    };
  },

  computed: {
    extractedData() {
      if (!this.workspacesProvider) {
        return { classes: [], assignments: [] };
      }
      return this.workspacesProvider.extractClassesAndAssignments();
    },
  },

  watch: {
    value() {
      this.selectedAssignment = this.value;
    },
  },

  methods: {
    selectAssignment(selectedAssignment) {
      if (selectedAssignment) {
        this.selectedAssignment = selectedAssignment;
        this.$emit("input", selectedAssignment);
      }
    },
  },
};
</script>
